import React from 'react'
import Advisor from '../../Components/Advisor'
import Footer from '../../Components/Footer'
import Navbar from '../../Components/Navbar'

const AdServices = () => {
    return (
        <>
            <Navbar />
            <Advisor/>
            <Footer />
        </>
    )
}

export default AdServices